import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionReducer from "./sessionReducer";
import commonReducer from "./commonReducer";
import CommiteeReducer from "pages/Commitee/reducers/CommiteeReduer";
import IncidentReducer from "pages/Overview/reducers/IncidentReduer";
import { IncidentPreventionReducer } from "pages/Overview/reducers";
import { ScopesReducer } from "pages/Scopes/reducers";
import { incidentFailure } from "actions";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["session"],
};

const appReducer = combineReducers({
  session: sessionReducer,
   commonState: commonReducer,
   commiteeState: CommiteeReducer,
   incidentState:IncidentReducer,
   scopesState: ScopesReducer,
   incidentPreventionActionState: IncidentPreventionReducer
});

const RootReducer = (state, action) => {
  if (action.type === "TOKEN_EXPIRE" || action.type === "SESSION_LOGOUT") {
    state = undefined;
    localStorage.removeItem("token");
    sessionStorage.clear();
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, RootReducer);
